import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/money/withdrawrecord/`;

const saveWithdrawRecord = async (formData) => {
    return await axios.post(API_URL, formData);
};

const getWithdrawRecords = async () => {
    return await axios.get(API_URL);
};

const deleteWithdrawRecord = async (id) => {
    return await axios.delete(`${API_URL}${id}`);
};

const updateWithdrawRecord = async (id, formData) => {
    return await axios.put(`${API_URL}${id}`, formData);
};

const saveWithdrawRecordsBulk = async (payload) => {
    return await axios.post(`${API_URL}bulk`, payload);
};

const getCurrencyRateByDate = async (dateStr) => {
    return await axios.get(`${BACKEND_URL}/api/money/currency/by-date`, { params: { date: dateStr } });
};

export default {
    saveWithdrawRecord,
    getWithdrawRecords,
    getCurrencyRateByDate,
    deleteWithdrawRecord,
    updateWithdrawRecord,
    saveWithdrawRecordsBulk,
};
